import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { Observable } from "rxjs";
import { IAPIListResult, IPagination, IPaginationResult } from "app/common/interfaces";
import { andAllWhere, andWhere, buildQuery, Normalizers, Ops, orderBy, OrderVariant, page, where } from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import MaterialPriceListScaleAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-price-list-scales/material-price-list-scales.entity";

const apiUrl = env.API_MATERIAL_PRICE_LIST_URL;
const moduleName = "material_price_list_scale";

@Injectable({
  providedIn: "root",
})
export class MaterialPriceListScaleService extends AbstractService<MaterialPriceListScaleAttributes, MaterialPriceListScaleAttributes, MaterialPriceListScaleAttributes> {
    constructor(
        http: HttpClient,
    ) {
        super(apiUrl, moduleName, http);
    }

    /**
     * List
     * @param filter CombinedFilter of related entity - MaterialPriceListScaleAttributes
     * @returns Data list
     */
    getAllMaterialScale(materialPriceId: string): Observable<IAPIListResult<MaterialPriceListScaleAttributes>> {
        const API_URL: string = apiUrl + `api/${moduleName}/${materialPriceId}`;
        return this.http.get<IAPIListResult<MaterialPriceListScaleAttributes>>(API_URL);
    }
}
